(function ($) {

    'use strict';
    $(function () {

        const filterContainer = $('.js-filter-section');

        if (!filterContainer.length) {
            return;
        }

        $('.js-redirect-program-table').on('click', function (e) {
            e.preventDefault();
            let searchParams = new URLSearchParams(window.location.search);
            window.location.href = `${localize.programtableurl}${[...searchParams].length > 0 ? `?${searchParams}` : ``}`
        });

        $('.js-redirect-program-archive').on('click', function (e) {
            e.preventDefault();
            let searchParams = new URLSearchParams(window.location.search);
            window.location.href = `${localize.programarchiveurl}${[...searchParams].length > 0 ? `?${searchParams}` : ``}`

        });

        $('.js-filter-toggle-programs').on('click', function () {
            filterContainer.toggleClass('active')
        });


        /* Get URL paremeters */
        var filterDates = $.getUrlParameter('napok');
        if (filterDates != undefined && filterDates != "") {
            var dates = filterDates.split(',');
            $.each(dates, function (i, val) {
                var currentItem = $(`.js-filter-select--date option[value=${val}]`);
                currentItem.attr('selected', true);
            });
        }

        var filterPlaces = $.getUrlParameter('helyszinek');
        if (filterPlaces != undefined && filterPlaces != "") {
            var places = filterPlaces.split(',');
            $.each(places, function (i, val) {
                var currentItem = $(`.js-filter-select--place option[value=${val}]`);
                currentItem.attr('selected', true);
            });
        }


        var filterType = $.getUrlParameter('tipus');
        if (filterType != undefined && filterType != "") {
            var places = filterType.split(',');
            $.each(places, function (i, val) {
                var currentItem = $(`.js-filter-select--types option[value=${val}]`);
                currentItem.attr('selected', true);
            });
        }


        var filterFree = $.getUrlParameter('ingyenes');
        if (filterFree != undefined && filterFree != "") {
            if (filterFree == '1') {
                $('.js-filter-checkbox').attr('checked', true);
            }
        }


        /* Init filter controls */
        const datesFilter = $('.js-filter-select--date');
        const placeFilter = $('.js-filter-select--place');
        const typeFilter = $('.js-filter-select--types');
        const freeFilter = $('.js-filter-checkbox');

        datesFilter.SumoSelect({
            placeholder: "Napok",
            captionFormat: "{0} nap kiválasztva",
            captionFormatAllSelected: "Összes nap kiválasztva"
        });

        placeFilter.SumoSelect({
            placeholder: "Helyszínek",
            captionFormat: "{0} helyszín kiválasztva",
            captionFormatAllSelected: "Összes helyszín kiválasztva"
        });

        typeFilter.SumoSelect({
            placeholder: "Program típusa",
            captionFormat: "{0} program kiválasztva",
            captionFormatAllSelected: "Összes program kiválasztva"
        });

        datesFilter.on('change', function () {
            let currentValue = $(this).val();
            let closestFilter = $(this).closest('.js-filter');
            let currentType = closestFilter.data('type');

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));

            updateList();
        });

        placeFilter.on('change', function () {
            let currentValue = $(this).val();
            let closestFilter = $(this).closest('.js-filter');
            let currentType = closestFilter.data('type');

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));
            updateList();
        });

        typeFilter.on('change', function () {
            let currentValue = $(this).val();
            let closestFilter = $(this).closest('.js-filter');
            let currentType = closestFilter.data('type');

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));
            updateList();
        });

        freeFilter.on('change', function () {
            let currentValue = $(this).is(':checked') ? 1 : 0;
            let closestFilter = $(this).closest('.js-filter');
            let currentType = closestFilter.data('type');

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));
            updateList();
        });

        $('.js-filter-type').on('click', function () {
            let currentValue = $(this).parent().data('type');
            let currentType = 'tipus';

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));

            typeFilter[0].sumo.selectItem(currentValue)

            window.scrollTo(0, 0);
            updateList();
        });


        var filterInstance = [];
        var filterOptions = {
            valueNames: [{
                data: ['date', 'place', 'type', 'free']
            }]
        };

        var isProgramTable = $('.template-program-table').length;


        $('.js-programs-list').each(function (i, e) {
            filterInstance.push(new List(e, filterOptions));
        });



        /* If filter page has url paremeters then update list */
        if (filterDates || filterPlaces || filterType || filterFree) {
            updateList();
        }

        function updateList() {
            let valueDates = $('.js-filter-select--date').val();
            let valuePlaces = $('.js-filter-select--place').val();
            let valueTypes = $('.js-filter-select--types').val();
            let valueFree = $('.js-filter-checkbox').is(':checked');

            if (valueFree) {
                valueFree = [$('.js-filter-checkbox').is(':checked')]
            } else {
                valueFree.length === 0;
            }

            $.each(filterInstance, (i, e) => {
                var programsList = e;


                var programsListParent = $(programsList.list).parent();
                var programsListParentParent = programsListParent.parent();


                programsList.filter(function (item) {
                    let datesFilter = false;
                    let placesFilter = false;
                    let typesFilter = false;
                    let freeFilter = false;

                    if (valueDates.length == 0) {
                        datesFilter = true;
                    } else {
                        datesFilter = valueDates.some(a => item.values().date.includes(a));
                    }

                    if (valueTypes.length == 0) {
                        typesFilter = true;
                    } else {
                        typesFilter = valueTypes.some(a => item.values().type.includes(a));
                    }

                    if (valuePlaces.length == 0) {
                        placesFilter = true;
                    } else {
                        placesFilter = valuePlaces.some(a => item.values().place.includes(a));
                    }

                    if (!valueFree.length) {
                        freeFilter = true
                    } else {
                        freeFilter = valueFree.some(a => item.values().free.includes(a));
                    }

                    return datesFilter && placesFilter && typesFilter && freeFilter;
                });


                programsList.update();

                if (isProgramTable) {

                    /* Check list days has matching items */
                    if (programsList.matchingItems.length > 0) {
                        programsListParent.removeClass('d-none')
                    } else {
                        programsListParent.addClass('d-none')
                    }

                    // /* Check list location has matching items */
                    if (programsListParentParent.find('.js-programs-list').not('.d-none').length > 0) {
                        programsListParentParent.closest('.js-location-rows').removeClass('d-none')
                    } else {
                        programsListParentParent.closest('.js-location-rows').addClass('d-none')
                    }

                    if (valuePlaces.length > 0) {
                        $('.js-location-rows').addClass('d-none');


                        valuePlaces.forEach(function (locationId) {
                            var $currentRow = $('.js-location-rows[data-location-id="' + locationId + '"]');

                            if ($currentRow.find('.js-programs-list').not('.d-none').length > 0) {
                                $currentRow.removeClass('d-none');
                            }
                        });
                    }

                    /* Check the full list has matching items */
                    if ($('.js-program-table-wrapper').find('.js-location-rows').not('.d-none').length > 0) {
                        $('.js-no-result').addClass("d-none");
                    } else {
                        $('.js-no-result').removeClass("d-none");
                    }

                } else {
                    if (!programsList.matchingItems.length > 0) {
                        $('.js-no-result').removeClass("d-none")
                    } else {
                        $('.js-no-result').addClass("d-none")
                    }
                }

            })

        }
    });
})(jQuery);